import axios from "axios";

import Config from "../../..//../config";

const v2_action_crm_leadsPorUsuarios = querys => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/dashboard/relatorios/crm/leads-usuarios${querys}`
    });
};

export default v2_action_crm_leadsPorUsuarios;
